import React from "react";

// import hoc
import { withFeature, withErrorBoundary } from "lib/hoc";

// import generic component
import { ChangePassword } from "app/userManagement/modules/generic";

// import constant
import constant from "lib/constant/constant";

const OperatorChangePassword = () => {
  return <ChangePassword />;
};

export default withFeature(withErrorBoundary(OperatorChangePassword), { feature: constant.CHANGE_PASSWORD });
